import { DelegateTypesEnum } from 'enums/global.enum';
import DelegateManagement from 'shared/_components/delegate-management';

const DelegateManagementPage: React.FC = () => {
  return <DelegateManagement type={DelegateTypesEnum.HCC} />;
};

export default DelegateManagementPage;
